import { DragEvent, useState, ChangeEvent, useCallback, useRef } from 'react'
import cn from 'classnames'
import { IconCloud, IconTrash } from './upload.icons'
import { UploadProps } from './upload.interface'
import './upload.style.scss'

export const Upload = ({
  onUpload,
  className,
  description,
  percent = 0,
  disabled = false,
  uploading = false,
  variant = 'information',
  label = 'Pilih dokumen',
  title = 'Pilih atau seret dokumen disini',
  ...rest
}: UploadProps) => {
  const [, setIsDragging] = useState(false)
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleDragOver = useCallback((e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    if (!disabled) {
      setIsDragging(true)
    }
  }, [disabled])

  const handleDragLeave = useCallback(() => {
    setIsDragging(false)
  }, [])

  const handleDrop = useCallback((e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    setIsDragging(false)
    if (!disabled && e.dataTransfer.files) {
      onUpload?.(e.dataTransfer.files)
    }
  }, [disabled, onUpload])

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      onUpload?.(e.target.files)
    }
  }, [onUpload])

  const handleClick = () => {
    if (!disabled && inputRef.current) {
      inputRef.current.click()
    }
  }

  const classWrapper = cn(className, {
    'legion-upload': true,
    'legion-upload--disabled': disabled,
    [`legion-upload--${variant}`]: true,
  })

  return (
    <div
      className={classWrapper}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
      title={title}
    >
      <input
        {...rest}
        className='legion-upload__input'
        type="file"
        ref={inputRef}
        onChange={handleChange}
        multiple
        disabled={disabled}
      />
      <span className='legion-upload__inner'>
        <span className="legion-upload__icon">
          {uploading ? <IconTrash/> : <IconCloud/>}
        </span>
        <span className="legion-upload__content">
          <span className="legion-upload__title">{title}</span>
          <span className="legion-upload__description">{description}</span>
          {uploading && (
            <div className="legion-upload__progress-track">
              <div className="legion-upload__progress-filler" style={{ width: `${percent}%` }}></div>
            </div>
          )}
        </span>
        <span className="legion-upload__label">{label}</span>
      </span>
    </div>
  )
}
